@if (isItemLoading() || (isJobLoading() && !dashboardTab.defaultDashboardJobId())) {
  <cor-skeleton [type]="SKELETON_TYPES.DASHBOARD" />
} @else if (notFound()) {
  <cor-not-found [notFoundMessage]="`Could not find this ${OBJECT_DISPLAY_NAME[object()]} job.`" />
} @else if (forbidden()) {
  <cor-forbidden />
} @else if (item()?.id && currentProject() !== item()?.projectSlug) {
  <cor-invalid-project [item]="item()" />
} @else if (job()?.id) {
  <!-- Now, we support group approval, and lineage object's simulation can be used for other's approval
    When the current object's job is used for simulation, we show the job dashboard with the job details, results,
    and reports tabs used while running the simulation.
    For the other cases, we show the link of the simulation used for the approval
    -->
  <div class="tw:h-full">
    <div
      class="tw:py-2 tw:px-5 tw:sticky tw:top-0 tw:z-10 tw:bg-(--p-content-background) tw:px-3 tw:pt-2 tw:flex-auto tw:flex tw:flex-row tw:items-center tw:justify-between"
      test-id="name-bar">
      @if (!isJobDetailsPage() && dashboardTab.showChangeOption()) {
        <div class="tw:flex tw:items-center tw:gap-2 tw:grow">
          <p-select
            test-id="job-dashboard-type-or-search-for-jobs"
            class="col-5"
            [(ngModel)]="dashboardTab.selectedJobId"
            [placeholder]="
              dashboardTab.isJobListLoading() ? 'Loading...' : 'Type or search for Jobs'
            "
            [options]="dashboardTab.jobList()"
            (ngModelChange)="loadReports(dashboardTab.selectedJobId())"
            [filter]="true"
            [showClear]="true"
            optionLabel="name"
            optionValue="id"
            filterBy="name" />

          <p-button
            test-id="job-dashboard-on-dashboard-change-save-click"
            (click)="onDashboardChangeSaveClick()"
            [disabled]="dashboardTab.isSavingDashboard()"
            [buttonProps]="{ autofocus: false }"
            severity="primary">
            <i
              class="pi pi-check tw:py-1"
              [ngClass]="{
                'pi-spin pi-spinner': dashboardTab.isSavingDashboard(),
              }"></i>
          </p-button>
          <p-button
            test-id="job-dashboard-on-dashboard-change-cancel-click"
            (click)="onDashboardChangeCancelClick()"
            [buttonProps]="{ autofocus: false }"
            severity="danger"
            variant="outlined">
            <i class="pi pi-times tw:py-1"></i>
          </p-button>
        </div>
      } @else {
        <div
          class="tw:flex tw:gap-1 tw:items-center tw:justify-between col"
          [ngClass]="{
            'tw:flex-row-reverse': comparison.flipped(),
          }">
          <div class="tw:flex tw:font-bold tw:text-xl tw:truncate tw:gap-2 col">
            <cor-input-editor
              class="tw:w-full tw:flex"
              [formControl]="jobNameFormControl"
              (onSave)="onNameUpdate($event)"
              test-id="name" />
            <!-- Changing the dashboard is only supported in simulatable objects -->
            @if (
              dashboardTab.hasObjectWriteAccess() &&
              !isJobDetailsPage() &&
              (SIMULATABLE_OBJECTS | includes: object()) &&
              !comparison.isComparisonViewActive()
            ) {
              <p-button
                test-id="job-dashboard-change"
                [buttonProps]="{ autofocus: false }"
                (click)="showDashboardChangeOption()"
                variant="text"
                severity="primary"
                label="Change"
                pTooltip="Choose another job to be shown in the dashboard"
                styleClass="tw:py-0" />
            }
          </div>

          @if (comparison.isComparisonViewActive()) {
            <div class="tw:flex tw:items-center tw:text-muted-color tw:font-bold tw:ms-5">
              <p-button
                test-id="job-dashboard-flip-comparison-view-swap-left-and-right"
                [buttonProps]="{ autofocus: false }"
                icon="pi pi-arrow-right-arrow-left"
                variant="text"
                (click)="toggleSignal(comparison.flipped)"
                pTooltip="Flip comparison view - swap left and right panels" />
            </div>
            <div
              class="col tw:rounded-sm tw:border tw:border-surface tw:flex tw:items-center tw:gap-2">
              <p-select
                test-id="job-dashboard-loading"
                [panelStyle]="{ 'max-width': '10rem' }"
                class="col tw:border-transparent tw:overflow-hidden tw:transition-[width] tw:duration-300 tw:ease-in-out"
                [ngClass]="{
                  'tw:max-w-0': !comparison.isObjectSelectionVisible(),
                }"
                [(ngModel)]="comparison.selectedObjectId"
                [placeholder]="
                  comparison.isObjectListLoading() ? 'Loading...' : `Type or search for ${object()}`
                "
                [options]="comparison.objectList()"
                (ngModelChange)="getSimulationList()"
                [filter]="true"
                [showClear]="false"
                appendTo="body"
                optionLabel="name"
                optionValue="id"
                filterBy="name">
                <ng-template
                  #item
                  let-item>
                  <div
                    class="tw:flex tw:w-full tw:min-w-0 tw:items-center tw:justify-between tw:gap-2">
                    <span
                      class="tw:min-w-0 tw:flex-1 tw:truncate"
                      [title]="item.name">
                      {{ item.name }}
                    </span>
                    @if (item.version) {
                      <p-tag
                        [value]="`v${item.version}`"
                        severity="secondary"
                        class="tw:shrink-0" />
                    }
                  </div>
                </ng-template>
              </p-select>

              <p-button
                test-id="job-dashboard-"
                [buttonProps]="{ autofocus: false }"
                (click)="toggleSignal(comparison.isObjectSelectionVisible)"
                variant="text"
                severity="primary"
                size="small"
                [label]="comparison.isObjectSelectionVisible() ? '←' : '→'"
                [pTooltip]="`Change ${object()}`"
                styleClass="tw:py-0" />
              <p-select
                test-id="job-dashboard-type-or-search-for-jobs-2"
                [panelStyle]="{ 'max-width': '10rem' }"
                class="col tw:border-transparent"
                [(ngModel)]="comparison.selectedJobId"
                [placeholder]="
                  comparison.isJobListLoading() ? 'Loading...' : 'Type or search for Jobs'
                "
                [options]="comparison.jobList()"
                (ngModelChange)="updateComparisonQueryparam()"
                [filter]="true"
                appendTo="body"
                optionLabel="name"
                optionValue="id"
                filterBy="name" />
            </div>
          }
        </div>
      }
      @if (job() && object() !== OBJECTS.ANNOTATION_QUEUE) {
        <cor-job-model-usage [job]="job()" />
      }
      <ng-template [ngTemplateOutlet]="actionTemplate" />
    </div>
    @if ((isJobLoading() && dashboardTab.defaultDashboardJobId()) || comparison.isLoading()) {
      <div class="tw:relative">
        <cor-skeleton [type]="SKELETON_TYPES.DASHBOARD" />
        <cor-loading-state
          [isLoading]="true"
          slowMessage="Large data may take a few minutes." />
      </div>
    } @else {
      <div class="col-12">
        <p-tabs
          [scrollable]="true"
          [(value)]="activeIndex"
          (valueChange)="updateTabQueryParam($event)">
          <!-- Tab Headers -->
          <p-tablist
            class="tw:flex tw:items-center"
            [ngStyle]="{
              'font-size': '0.95rem',
            }">
            <p-tab
              [value]="0"
              test-id="jobtab-job-details">
              <div class="tw:flex tw:items-center tw:gap-2">
                <i class="pi pi-book"></i>
                Job Details
              </div>
            </p-tab>
            <p-tab
              [value]="1"
              test-id="jobtab-job-results">
              <div class="tw:flex tw:items-center tw:gap-2">
                <i class="pi pi-list-check"></i>
                Job Results
              </div>
            </p-tab>

            <!-- Keep evaluation tabs available when data preparation fails so users can inspect the error. -->
            @if (
              job().jobStatus !== SCHEDULED_JOB_STATUS.FAILED ||
              reportEvaluations.dataPreparationStep()?.status === JOB_STEP_STATUS.FAILED
            ) {
              @for (tab of evalTabs(); track $index) {
                @let evalInfo = reportEvaluations.evalMap()[tab.evaluationId];
                <p-tab
                  [value]="2 + $index"
                  [attr.test-id]="'jobtab-' + tab.title"
                  [pTooltip]="
                    (evalInfo?.summary?.status === JOB_STEP_STATUS.PENDING &&
                      'This report is pending and will start shortly.') ||
                    (evalInfo?.summary?.status === JOB_STEP_STATUS.IN_PROGRESS &&
                      'This report is currently in progress. Please wait until it completes.') ||
                    (evalInfo?.summary?.status === JOB_STEP_STATUS.PARTIAL_SUCCESS &&
                      'This report was completed but some results may have failed. Please check logs.') ||
                    (evalInfo?.summary?.status === JOB_STEP_STATUS.FAILED &&
                      'This report has encountered an error and failed. Please check for issues or retry.')
                  ">
                  <div class="tw:flex tw:items-center tw:gap-2">
                    <!-- show the current report status icon-->
                    @if (evalInfo?.summary?.status === JOB_STEP_STATUS.PENDING) {
                      <i class="pi pi-clock"></i>
                    } @else if (evalInfo?.summary?.status === JOB_STEP_STATUS.IN_PROGRESS) {
                      <i class="pi pi-spin pi-stop-circle"></i>
                    } @else if (
                      [JOB_STEP_STATUS.PARTIAL_SUCCESS, JOB_STEP_STATUS.FAILED]
                        | includes: evalInfo?.summary?.status
                    ) {
                      <i class="pi pi-exclamation-triangle"></i>
                    } @else {
                      <i class="pi pi-chart-bar"></i>
                    }
                    {{ tab.title }}
                  </div>
                </p-tab>
              }
              @if (
                canEditEvals() &&
                job().jobStatus === SCHEDULED_JOB_STATUS.COMPLETED &&
                !comparison.isComparisonViewActive()
              ) {
                <p-button
                  test-id="job-dashboard-add-evaluation"
                  [buttonProps]="{ autofocus: false }"
                  class="tw:my-auto"
                  icon="pi pi-plus"
                  size="small"
                  variant="outlined"
                  severity="secondary"
                  pTooltip="Add Evaluation"
                  tooltipPosition="bottom"
                  (click)="addEvaluationDialog.open()" />
              }
            }
          </p-tablist>

          <!-- This divider is for showing tw:border bottom on the sticky topbar -->
          <div
            class="tw:border-b tw:border-surface tw:sticky tw:top-[3.4rem] tw:z-10 tw:h-[0.1em]"></div>
          <!-- Tab Panels -->
          <p-tabpanels class="tw:p-3">
            <p-tabpanel [value]="0">
              @defer (when activeIndex() === 0) {
                <div
                  class="row"
                  [ngClass]="{
                    'tw:flex-row-reverse': comparison.flipped(),
                    'hide-hillclimbing-prompt': comparison.isComparisonViewActive(),
                  }">
                  <!-- Compariosn job details -->
                  @if (comparison.isComparisonViewActive()) {
                    @if ((hillClimb.prompts() | keyvalue).length > 0 || hillClimb.isLoading()) {
                      <!-- Show the prompt diffs only for pipeline hillclimb jobs in comparison view-->
                      <p-panel
                        [toggleable]="true"
                        class="tw:mb-2"
                        iconPos="start"
                        toggler="header">
                        <!-- Start: header icon -->
                        <ng-template
                          #headericons
                          let-collapsed>
                          <i
                            class="pi"
                            [ngClass]="{
                              'pi-chevron-down': !collapsed,
                              'pi-chevron-right': collapsed,
                            }"></i>
                        </ng-template>
                        <!-- End: header icon -->

                        <ng-template #header>
                          <div class="tw:whitespace-nowrap tw:text-xl tw:w-full">Prompts</div>
                        </ng-template>

                        @if (hillClimb.isLoading()) {
                          <cor-skeleton [type]="SKELETON_TYPES.RUN_JOB_DETAILS" />
                        } @else {
                          <div class="tw:p-0 tw:mb-3">
                            @for (prompt of hillClimb.prompts(); track prompt) {
                              @if (comparison.flipped()) {
                                <cor-diff-viewer
                                  [attr.test-id]="'hillclimb-prompt-diff-' + prompt.entityName"
                                  [leftValue]="prompt?.rightPromptTemplate"
                                  [rightValue]="prompt?.leftPromptTemplate"
                                  [leftTitle]="prompt.entityName"
                                  [rightTitle]="prompt.entityName"
                                  language="plaintext" />
                              } @else {
                                <cor-diff-viewer
                                  [attr.test-id]="'hillclimb-prompt-diff-' + prompt.entityName"
                                  [leftValue]="prompt?.leftPromptTemplate"
                                  [rightValue]="prompt?.rightPromptTemplate"
                                  [leftTitle]="prompt.entityName"
                                  [rightTitle]="prompt.entityName"
                                  language="plaintext" />
                              }
                            }
                          </div>
                        }
                      </p-panel>
                    }

                    <!-- Left job -->
                    <cor-run-job-details
                      class="col-6"
                      [entityId]="id()"
                      [jobId]="comparison.leftJob()?.id"
                      [isExisitingJob]="true"
                      (showLogsEvent)="showLogs()"
                      (updateJob)="updateJobData($event)" />
                    <!-- Right job -->
                    @if (comparison.rightJob()) {
                      <cor-run-job-details
                        class="col-6"
                        [ngStyle]="{
                          'tw:border-l':
                            !comparison.flipped() && '0.15em dashed var(--p-content-border-color)',
                          'tw:border-r':
                            comparison.flipped() && '0.15em dashed var(--p-content-border-color)',
                        }"
                        [entityId]="id()"
                        [jobId]="comparison.rightJob().id"
                        [isExisitingJob]="true" />
                    } @else {
                      <div
                        class="tw:text-xl tw:text-center tw:text-muted-color-emphasis col-6 tw:pt-4"
                        [ngStyle]="{
                          'tw:border-l':
                            !comparison.flipped() && '0.15em dashed var(--p-content-border-color)',
                          'tw:border-r':
                            comparison.flipped() && '0.15em dashed var(--p-content-border-color)',
                        }">
                        Please select a job to compare
                      </div>
                    }
                  } @else {
                    <cor-run-job-details
                      [entityId]="id()"
                      [jobId]="job()?.id"
                      [isExisitingJob]="true"
                      (showLogsEvent)="showLogs()"
                      (updateJob)="updateJobData($event)" />
                  }
                </div>
              }
            </p-tabpanel>

            <p-tabpanel [value]="1">
              @defer (when activeIndex() === 1) {
                <div
                  class="row"
                  [ngClass]="{
                    'tw:flex-row-reverse': comparison.flipped(),
                  }">
                  <!-- Compariosn Job Result -->
                  @if (comparison.isComparisonViewActive()) {
                    <cor-job-results
                      [ngClass]="{
                        'col-6': comparison.isComparisonViewActive(),
                      }"
                      [job]="comparison.leftJob()"
                      [object]="object()" />
                    @if (comparison.rightJob()) {
                      <cor-job-results
                        [ngClass]="{
                          'col-6': comparison.isComparisonViewActive(),
                        }"
                        [ngStyle]="{
                          'border-left':
                            !comparison.flipped() && '0.15em dashed var(--p-content-border-color)',
                          'border-right':
                            comparison.flipped() && '0.15em dashed var(--p-content-border-color)',
                        }"
                        [job]="comparison.rightJob()"
                        [object]="object()" />
                    } @else {
                      <div
                        class="tw:text-xl tw:text-center tw:text-muted-color-emphasis col-6 tw:pt-4"
                        [ngStyle]="{
                          'border-left':
                            !comparison.flipped() && '0.15em dashed var(--p-content-border-color)',
                          'border-right':
                            comparison.flipped() && '0.15em dashed var(--p-content-border-color)',
                        }">
                        Please select a job to compare
                      </div>
                    }
                  } @else {
                    <cor-job-results
                      [ngClass]="{
                        'col-6': comparison.isComparisonViewActive(),
                      }"
                      [job]="job()"
                      [object]="object()"
                      (updateJob)="updateJobData($event)" />
                  }
                </div>
              }
            </p-tabpanel>

            <!-- Keep evaluation panels available when data preparation fails. -->
            @if (
              job().jobStatus !== SCHEDULED_JOB_STATUS.FAILED ||
              reportEvaluations.dataPreparationStep()?.status === JOB_STEP_STATUS.FAILED
            ) {
              @for (tab of evalTabs(); track tab.evaluationId) {
                @let evalInfo = reportEvaluations.evalMap()[tab.evaluationId];
                <p-tabpanel
                  [value]="2 + $index"
                  [attr.test-id]="'jobtab-panel-' + tab.title">
                  <!-- NOTE: Since primeng v18 lazy-load for tabpanels doesn't work so we are using angular defer to load content only for active tab -->
                  <!-- Refer: https://github.com/primefaces/primeng/issues/17351 -->
                  @defer (when activeIndex() === 2 + $index) {
                    <!--  Today we use dataLogicSourceId for inline reports.
                        Later on we might want to change this ... but checking on dataLogicSourceId for now -->
                    @if (evalInfo?.dataLogic?.dataLogicSourceId) {
                      @if (canEditEvals()) {
                        <div class="tw:flex tw:justify-end tw:mb-2">
                          <p-button
                            test-id="job-dashboard-delete-evaluation"
                            #deleteEvalBtn
                            [buttonProps]="{ autofocus: false }"
                            label="Delete Evaluation"
                            variant="outlined"
                            severity="danger"
                            size="small"
                            (click)="deleteEvaluation(deleteEvalBtn, tab)" />
                        </div>
                      }
                      <cor-inline-report
                        [inlineReport]="{ id: tab.reportId, evaluationId: tab.evaluationId }"
                        [job]="job()"
                        [object]="object()"
                        [jobAssets]="evalInfo?.jobAssets || []"
                        [dataLogicInputs]="reportEvaluations.dataLogicInputList()"
                        [canEdit]="canEditEvals()"
                        [comparisonViewActive]="comparison.isComparisonViewActive()"
                        [jobService]="service"
                        (refreshRequested)="refreshJob()" />
                    } @else {
                      <!-- Report Details -->
                      @if (
                        evalInfo?.summary &&
                        !comparison.selectedJobId() &&
                        reportEvaluations.dataPreparationStep()?.status !== JOB_STEP_STATUS.FAILED
                      ) {
                        <div class="tw:flex tw:justify-between tw:mb-3 tw:ms-2 tw:me-2">
                          @if (
                            [
                              JOB_STEP_STATUS.SUCCESSFUL,
                              JOB_STEP_STATUS.FAILED,
                              JOB_STEP_STATUS.PARTIAL_SUCCESS,
                            ] | includes: evalInfo?.summary?.status
                          ) {
                            <div class="tw:text-muted-color tw:items-center tw:flex tw:gap-2">
                              <i class="pi pi-chart-bar tw:text-xl"></i>
                              Generated
                              {{
                                evalInfo?.summary.totalOutputs
                                  | i18nPlural: { '=1': '1 output', other: '# outputs' }
                              }}
                              in
                              {{
                                evalInfo?.summary.duration
                                  ? (evalInfo?.summary.duration | timeTaken)
                                  : 'N/A'
                              }}
                              @if (evalInfo?.summary.failed) {
                                ({{ evalInfo?.summary.failed }} failed)
                              }
                              <p-button
                                test-id="job-dashboard-view-details"
                                [buttonProps]="{ autofocus: false }"
                                (click)="toggleSignal(tab.isDetailsVisible)"
                                variant="text"
                                severity="primary"
                                size="small"
                                [label]="tab.isDetailsVisible() ? 'Hide Details' : 'View Details'"
                                styleClass="tw:text-base tw:py-0" />
                            </div>
                          }
                          <div class="tw:flex tw:gap-3">
                            @if (reportLink()[tab.reportId]?.link) {
                              <a
                                class="tw:flex tw:items-center tw:gap-2"
                                pTooltip="Click here to open the snapshot of this Report"
                                test-id="goto-report-btn"
                                [routerLink]="reportLink()[tab.reportId].link"
                                target="_blank">
                                Goto Report
                                <i class="coricon-external-link"></i>
                              </a>
                            }

                            @if (
                              isRerunAllFiguresOptionVisible() &&
                              isRerunAllFiguresOptionVisible()[tab.title]
                            ) {
                              <p-button
                                test-id="job-dashboard-rerun-all-figures"
                                [buttonProps]="{ autofocus: false }"
                                [icon]="
                                  isRerunningAllFigures() ? 'pi pi-sync pi-spin' : 'pi pi-sync'
                                "
                                [label]="
                                  isRerunningAllFigures() ? 'Running...' : 'Rerun All Figures'
                                "
                                severity="secondary"
                                styleClass="tw:bg-emphasis"
                                size="small"
                                (click)="rerunAllFigures(tab)"
                                [disabled]="isRerunningAllFigures()" />
                            }
                          </div>
                        </div>

                        <div
                          [ngClass]="{
                            'tw:hidden':
                              ([
                                JOB_STEP_STATUS.SUCCESSFUL,
                                JOB_STEP_STATUS.FAILED,
                                JOB_STEP_STATUS.PARTIAL_SUCCESS,
                              ] | includes: evalInfo?.summary.status) && !tab.isDetailsVisible(),
                          }">
                          <div class="tw:flex tw:flex-col tw:gap-3 tw:mb-3">
                            <!-- START: Summary Cards -->
                            <div
                              class="tw:flex tw:flex-wrap tw:rounded-xl tw:border tw:border-surface tw:overflow-hidden">
                              <div
                                class="tw:flex tw:flex-col tw:gap-2 tw:p-3 tw:md:flex-1 tw:justify-between tw:shrink-0">
                                <div
                                  class="tw:text-xs tw:font-semibold tw:uppercase tw:text-muted-color">
                                  Current Status
                                </div>
                                <div
                                  class="tw:flex tw:flex-wrap tw:gap-2 tw:items-end tw:justify-between">
                                  <div class="tw:flex tw:items-center">
                                    <cor-status-icon [status]="evalInfo?.summary?.status" />
                                    @if (
                                      [
                                        SCHEDULED_JOB_STATUS.RUNNING,
                                        SCHEDULED_JOB_STATUS.COMPILING,
                                        SCHEDULED_JOB_STATUS.QUEUED,
                                        SCHEDULED_JOB_STATUS.SCHEDULED,
                                      ] | includes: job()?.jobStatus
                                    ) {
                                      <i
                                        test-id="job-dashboard-refresh"
                                        class="pi pi-refresh tw:ms-2 tw:cursor-pointer tw:text-sm"
                                        [ngClass]="{ 'tw:animate-spin': isRefreshing() }"
                                        (click)="refreshJob()"
                                        pTooltip="Refresh"
                                        aria-hidden="true"></i>
                                    }
                                  </div>
                                  @if (evalInfo?.summary?.endTime) {
                                    <span class="tw:text-xs tw:text-muted-color">
                                      {{
                                        'Completed' +
                                          ' ' +
                                          (evalInfo?.summary?.endTime | localDate: 'datetime')
                                      }}
                                    </span>
                                  }
                                </div>
                              </div>
                              <div
                                class="tw:flex tw:flex-col tw:justify-between tw:gap-2 tw:border-t tw:border-surface tw:p-3 tw:md:flex-1 tw:md:border-l tw:md:border-t-0 tw:shrink-0">
                                <div class="tw:flex tw:items-center tw:gap-2">
                                  <span
                                    class="tw:text-xs tw:font-semibold tw:uppercase tw:text-muted-color">
                                    Duration
                                  </span>
                                  <p-button
                                    test-id="job-dashboard-view-duration"
                                    [buttonProps]="{ autofocus: false }"
                                    (click)="durationBreakdownPopover.toggle($event)"
                                    variant="text"
                                    severity="primary"
                                    size="small"
                                    icon="pi pi-info-circle"
                                    label="View Duration"
                                    styleClass="tw:p-0 tw:text-xs tw:gap-1" />
                                  <!-- START: Duration Breakdown popover -->
                                  <p-popover #durationBreakdownPopover>
                                    @if (evalInfo?.durationBreakdown; as durationBreakdown) {
                                      <div
                                        class="tw:flex tw:items-center tw:justify-between tw:gap-3 tw:border-b tw:border-surface tw:px-4 tw:py-3">
                                        <div class="tw:flex tw:items-center tw:gap-2">
                                          <i class="pi pi-clock tw:text-muted-color"></i>
                                          <span class="tw:font-semibold">
                                            Run Duration Breakdown
                                          </span>
                                          <p-tag
                                            severity="secondary"
                                            [value]="
                                              'Total:' +
                                              ' ' +
                                              (durationBreakdown.totalDuration | timeTaken)
                                            " />
                                        </div>
                                        <button
                                          test-id="job-dashboard-close"
                                          type="button"
                                          class="tw:flex tw:size-6 tw:items-center tw:justify-center tw:rounded tw:border-0 tw:bg-transparent tw:text-muted-color"
                                          aria-label="Close"
                                          (click)="durationBreakdownPopover.hide()">
                                          <i class="pi pi-times"></i>
                                        </button>
                                      </div>
                                      <div
                                        class="tw:grid tw:grid-cols-1 tw:md:grid-cols-[14rem_1fr]">
                                        <div
                                          class="tw:border-b tw:border-surface tw:bg-surface-50 tw:p-4 tw:dark:bg-surface-900 tw:md:border-b-0 tw:md:border-r">
                                          <div
                                            class="tw:mb-3 tw:text-xs tw:font-semibold tw:uppercase tw:text-muted-color">
                                            Lifecycle
                                          </div>
                                          <p-timeline
                                            [value]="durationBreakdown.lifecycle"
                                            p-timeline-event-opposite="hidden"
                                            class="duration-breakdown-timeline tw:block">
                                            <ng-template
                                              pTemplate="marker"
                                              let-item>
                                              <span
                                                class="tw:block tw:size-3 tw:rounded-full tw:border-2 tw:bg-white"
                                                [ngClass]="item.markerClass"></span>
                                            </ng-template>
                                            <ng-template
                                              pTemplate="content"
                                              let-item>
                                              @if (item.value) {
                                                <div class="tw:pb-3">
                                                  <div
                                                    class="tw:text-xs tw:font-medium tw:text-muted-color">
                                                    {{ item.label }}
                                                  </div>
                                                  <div class="tw:text-sm tw:font-medium">
                                                    {{ item.value | localDate: 'datetime' }}
                                                  </div>
                                                  @if (item.author) {
                                                    <div class="tw:text-xs tw:text-muted-color">
                                                      {{ 'by' + ' ' + item.author }}
                                                    </div>
                                                  }
                                                </div>
                                              }
                                            </ng-template>
                                          </p-timeline>
                                        </div>
                                        <div class="tw:p-4">
                                          <div
                                            class="tw:mb-3 tw:flex tw:items-center tw:justify-between tw:gap-3">
                                            <span
                                              class="tw:text-xs tw:font-semibold tw:uppercase tw:text-muted-color">
                                              Workflow Stages
                                            </span>
                                          </div>
                                          <div class="tw:flex tw:flex-col tw:gap-3">
                                            @for (
                                              stage of durationBreakdown.stages;
                                              track stage.label
                                            ) {
                                              <div>
                                                <div
                                                  class="tw:mb-1 tw:flex tw:items-center tw:justify-between tw:gap-3">
                                                  <div
                                                    class="tw:flex tw:min-w-0 tw:items-center tw:gap-2">
                                                    <i
                                                      class="pi pi-check-circle tw:text-sm"
                                                      [ngClass]="{
                                                        'tw:text-green-600':
                                                          stage.status ===
                                                            JOB_STEP_STATUS.SUCCESSFUL ||
                                                          stage.status ===
                                                            JOB_STEP_STATUS.PARTIAL_SUCCESS,
                                                        'tw:text-red-600':
                                                          stage.status === JOB_STEP_STATUS.FAILED,
                                                        'tw:text-muted-color':
                                                          stage.status !==
                                                            JOB_STEP_STATUS.SUCCESSFUL &&
                                                          stage.status !==
                                                            JOB_STEP_STATUS.PARTIAL_SUCCESS &&
                                                          stage.status !== JOB_STEP_STATUS.FAILED,
                                                      }"></i>
                                                    <span class="tw:truncate tw:text-sm">
                                                      {{ stage.label }}
                                                    </span>
                                                  </div>
                                                  <div
                                                    class="tw:flex tw:shrink-0 tw:items-center tw:gap-4 tw:text-xs">
                                                    <span class="tw:font-semibold">
                                                      {{ stage.durationLabel }}
                                                    </span>
                                                    <span class="tw:text-muted-color">
                                                      {{ stage.shareLabel }}
                                                    </span>
                                                  </div>
                                                </div>
                                                <p-progressbar
                                                  [ngStyle]="{
                                                    '--p-progressbar-height': '0.25rem',
                                                  }"
                                                  [value]="stage.shareValue"
                                                  [showValue]="false" />
                                              </div>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    }
                                  </p-popover>
                                  <!-- END: Duration Breakdown popover -->
                                </div>
                                <div
                                  class="tw:flex tw:flex-wrap tw:gap-2 tw:items-center tw:justify-between">
                                  <div class="tw:text-sm tw:font-semibold">
                                    {{
                                      evalInfo?.summary.duration != null
                                        ? (evalInfo?.summary.duration | timeTaken)
                                        : 'N/A'
                                    }}
                                  </div>
                                  @if (evalInfo?.summary?.startTime) {
                                    <span class="tw:text-xs tw:text-muted-color">
                                      {{
                                        'Started' +
                                          ' ' +
                                          (evalInfo?.summary?.startTime | localDate: 'datetime')
                                      }}
                                    </span>
                                  }
                                </div>
                              </div>
                              <div
                                class="tw:flex tw:basis-full tw:flex-col tw:gap-2 tw:border-t tw:border-surface tw:p-3 tw:md:flex-1 tw:md:border-l tw:md:border-t-0">
                                <div
                                  class="tw:text-xs tw:font-semibold tw:uppercase tw:text-muted-color">
                                  Actions
                                </div>
                                <div class="tw:flex tw:flex-wrap tw:gap-2">
                                  @if (evalInfo?.jobAssets?.length) {
                                    <p-button
                                      [buttonProps]="{ autofocus: false }"
                                      test-id="show-assets-btn"
                                      (click)="toggleSignal(tab.isAssetsVisible)"
                                      variant="outlined"
                                      severity="secondary"
                                      size="small"
                                      icon="pi pi-sitemap"
                                      [label]="
                                        tab.isAssetsVisible() ? 'Hide Assets' : 'Show Assets'
                                      " />
                                  }
                                  @if (evalInfo?.logs) {
                                    <p-button
                                      [buttonProps]="{ autofocus: false }"
                                      test-id="show-logs-btn"
                                      (click)="toggleSignal(tab.isLogsVisible)"
                                      variant="outlined"
                                      severity="secondary"
                                      size="small"
                                      icon="pi pi-file"
                                      [label]="tab.isLogsVisible() ? 'Hide Logs' : 'View Logs'" />
                                  }
                                  @if (tab.evaluationId) {
                                    <p-button
                                      [buttonProps]="{ autofocus: false }"
                                      test-id="show-data-preview-btn"
                                      (click)="toggleEvalDataPreview(tab)"
                                      variant="outlined"
                                      severity="secondary"
                                      size="small"
                                      icon="pi pi-table"
                                      [label]="
                                        tab.previewData && tab.previewData.isVisible()
                                          ? 'Hide Data'
                                          : 'View Data'
                                      " />
                                  }
                                </div>
                              </div>
                            </div>
                            <!-- END: Summary Cards -->

                            <!-- START: Assets Section -->
                            @if (evalInfo?.jobAssets?.length && tab.isAssetsVisible()) {
                              <div class="tw:rounded-xl tw:border tw:border-surface">
                                <div
                                  class="tw:flex tw:items-center tw:gap-2 tw:px-3 tw:py-2 tw:border-b tw:border-surface">
                                  <i class="pi pi-sitemap tw:text-primary"></i>
                                  <span class="tw:font-semibold">
                                    Assets used to run this Report
                                  </span>
                                  <i
                                    pTooltip="The objects that were used in this job during submission"
                                    aria-hidden="true"
                                    class="pi pi-question-circle tw:align-super tw:text-xs"></i>
                                </div>
                                <div class="tw:flex tw:flex-col tw:gap-3 tw:p-3">
                                  @for (
                                    assetGroup of evalInfo?.jobAssetGroups || {} | keyvalue;
                                    track assetGroup.key
                                  ) {
                                    <div
                                      class="tw:grid tw:grid-cols-[10rem_1fr] tw:items-center tw:gap-3">
                                      <div class="tw:text-sm tw:text-muted-color">
                                        {{
                                          assetGroup.key === 'current'
                                            ? 'Current Object'
                                            : assetGroup.key
                                        }}
                                      </div>
                                      <div class="tw:flex tw:flex-wrap tw:gap-2">
                                        @for (
                                          asset of assetGroup.value;
                                          track `${asset.objectType}-${asset.name}`
                                        ) {
                                          <a
                                            test-id="job-dashboard-i"
                                            [ngStyle]="asset.objectType | objectIconPipe"
                                            class="tw:flex tw:items-center tw:gap-2 tw:px-2 tw:py-1 tw:rounded"
                                            style="font-size: 0.75rem"
                                            [attr.aria-label]="asset.name"
                                            [routerLink]="asset.url"
                                            [pTooltip]="
                                              !!asset.isModified
                                                ? 'This prompt was modified below.<br />Click here to open the snapshot that was used as the base for Hill Climbing.'
                                                : 'Click here to open the snapshot of this ' +
                                                  (OBJECT_DISPLAY_NAME[asset.objectType] ||
                                                    asset.objectType) +
                                                  '<br />Last updated on ' +
                                                  (asset.lastModifiedDate | localDate)
                                            "
                                            target="_blank">
                                            <i
                                              [ngClass]="(asset.objectType | objectIconPipe)?.icon"
                                              style="font-size: 0.75rem"></i>
                                            <span class="tw:truncate">
                                              {{ asset.name }}
                                            </span>
                                            @if (asset.isModified) {
                                              *
                                            }
                                          </a>
                                        }
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                            <!-- END: Assets Section -->

                            <!-- START: Logs Section -->
                            @if (evalInfo?.logs && tab.isLogsVisible()) {
                              <div
                                [id]="'report-logs-' + tab.reportId"
                                class="tw:rounded-xl tw:border tw:border-surface tw:overflow-hidden">
                                <div
                                  class="tw:flex tw:items-center tw:justify-between tw:gap-3 tw:px-3 tw:py-2 tw:border-b tw:border-surface">
                                  <div class="tw:flex tw:items-center tw:gap-2">
                                    <i class="pi pi-file tw:text-primary"></i>
                                    <span class="tw:font-semibold">Execution Logs</span>
                                  </div>
                                  <p-button
                                    test-id="job-dashboard-hide"
                                    [buttonProps]="{ autofocus: false }"
                                    (click)="toggleSignal(tab.isLogsVisible)"
                                    variant="text"
                                    severity="primary"
                                    size="small"
                                    label="Hide"
                                    styleClass="tw:py-0" />
                                </div>
                                <cor-code-block
                                  language="logs"
                                  [code]="evalInfo?.logs || 'No logs captured'" />
                              </div>
                            }
                            <!-- END: Logs Section -->

                            <!-- START: Data Preview Section -->
                            @if (tab.previewData && tab.previewData.isVisible()) {
                              <div
                                class="tw:rounded-xl tw:border tw:border-surface tw:overflow-hidden">
                                <div
                                  class="tw:flex tw:items-center tw:gap-2 tw:px-3 tw:py-2 tw:border-b tw:border-surface">
                                  <i class="pi pi-table tw:text-primary"></i>
                                  <span class="tw:font-semibold">Data Preview</span>
                                </div>
                                @if (tab.previewData.isLoading()) {
                                  <div class="tw:relative tw:p-3">
                                    <cor-skeleton [type]="SKELETON_TYPES.GRID" />
                                    <cor-loading-state
                                      [isLoading]="tab.previewData.isLoading()"
                                      slowMessage="Large reports may take a few minutes." />
                                  </div>
                                } @else {
                                  <div class="tw:p-3">
                                    <dx-data-grid
                                      #previewDataGrid
                                      [dataSource]="tab.previewData.gridDatasource()"
                                      [columns]="tab.previewData.columns()"
                                      noDataText="No data available"
                                      [scrolling]="{ useNative: true }"
                                      [columnAutoWidth]="true"
                                      [allowColumnResizing]="true"
                                      [repaintChangesOnly]="true"
                                      [showBorders]="true"
                                      [elementAttr]="{ class: 'data-grid-row-clickable' }"
                                      (onRowClick)="
                                        onPreviewDataRowClicked($event, previewDataGrid)
                                      ">
                                      <dxo-data-grid-sorting mode="multiple" />
                                      <dxo-data-grid-paging [pageSize]="20" />
                                      <dxo-data-grid-pager
                                        [showPageSizeSelector]="true"
                                        [allowedPageSizes]="[20, 50, 100]"
                                        [showNavigationButtons]="true"
                                        [showInfo]="true"
                                        [infoText]="tab.previewData.infoTextMarker()" />

                                      <div *dxTemplate="let cell of 'chatMessagesTemplate'">
                                        @if (!!cell.value) {
                                          <p-button
                                            test-id="job-dashboard-view-transcript"
                                            [buttonProps]="{ autofocus: false }"
                                            icon="pi pi-comments"
                                            label="View Transcript"
                                            severity="secondary"
                                            size="small"
                                            (click)="
                                              $event.stopPropagation();
                                              previewDataRowPanel.openPanel(
                                                previewDataGrid,
                                                cell.data?._index,
                                                'chat'
                                              )
                                            " />
                                        }
                                      </div>
                                    </dx-data-grid>
                                  </div>
                                }
                              </div>
                            }
                            <!-- END: Data Preview Section -->

                            <!-- START: Workflow Section -->
                            <div
                              class="tw:rounded-xl tw:border tw:border-surface tw:overflow-hidden">
                              <div
                                class="tw:flex tw:items-center tw:justify-between tw:gap-3 tw:px-3 tw:py-2 tw:border-b tw:border-surface">
                                <div class="tw:flex tw:items-center tw:gap-2">
                                  <i class="pi pi-sitemap tw:text-primary"></i>
                                  <span class="tw:font-semibold">Report Workflow</span>
                                  @if (
                                    evalInfo?.summary?.status === JOB_STEP_STATUS.SUCCESSFUL &&
                                    reportEvaluations.dataPreparationStep()?.status ===
                                      JOB_STEP_STATUS.SUCCESSFUL &&
                                    reportEvaluations.executionStep()?.status ===
                                      JOB_STEP_STATUS.SUCCESSFUL
                                  ) {
                                    <p-tag
                                      severity="success"
                                      value="3 of 3 stages complete" />
                                  }
                                </div>
                              </div>
                              <cor-job-workflow-builder-wrapper
                                [reportName]="tab.title"
                                [dataPreparationStatus]="
                                  reportEvaluations.dataPreparationStep()?.status
                                "
                                [executionStatus]="reportEvaluations.executionStep()?.status"
                                [reportStatus]="evalInfo?.summary?.status"
                                [figures]="evalInfo?.figures"
                                [dataLogic]="evalInfo?.dataLogic"
                                [showRerunFigureButton]="
                                  isRerunAllFiguresOptionVisible() &&
                                  isRerunAllFiguresOptionVisible()[tab.title]
                                "
                                [showDataPreview]="GGX_GLOBAL_OBJECTS | includes: object()"
                                (onDataPreview)="reportEvaluations.dataPreview.onShow($event)"
                                (onStepLogs)="reportEvaluations.stepLogsDialog.onShow($event)"
                                (onRerunReportFigure)="rerunReportFigure(tab.reportId, $event)"
                                (onFigureClick)="onFigureBlockClick($event)" />
                            </div>
                            <!-- END: Workflow Section -->
                          </div>
                        </div>
                      }

                      @if (
                        reportEvaluations.dataPreparationStep()?.status === JOB_STEP_STATUS.FAILED
                      ) {
                        <div class="tw:min-h-[410px] tw:flex">
                          <cor-error-block
                            title="Failed to generate this report"
                            message="The data sources could not be prepared for this report. View detailed logs for more information"
                            [supportPerson]="item()?.createdBy">
                            @if (evalInfo?.dataPreparationLogs) {
                              <ng-template #debugTemplate>
                                <cor-code-block
                                  language="logs"
                                  [code]="evalInfo.dataPreparationLogs" />
                              </ng-template>
                            }
                          </cor-error-block>
                        </div>
                      } @else if (
                        evalInfo?.summary?.status === JOB_STEP_STATUS.FAILED &&
                        evalInfo?.summary?.totalOutputs === 0
                      ) {
                        <div class="tw:min-h-[410px] tw:flex">
                          <cor-error-block
                            title="Failed to generate this report"
                            message="The report code or definition failed before any outputs were created. View detailed logs for more information."
                            [supportPerson]="evalInfo.owner">
                            @if (evalInfo?.logs) {
                              <ng-template #debugTemplate>
                                <cor-code-block
                                  language="logs"
                                  [code]="evalInfo.logs" />
                              </ng-template>
                            }
                          </cor-error-block>
                        </div>
                      } @else {
                        <!-- NOTE: We use bg with a tw:text-sm gap to make it look like we have only internal borders in the grid-->
                        <div class="tw:grid tw:grid-cols-12 tw:rounded-2xl tw:gap-4">
                          @for (tabReport of tab.data; track $index) {
                            @defer (on idle) {
                              <div
                                class="tw:col-span-12 tw:border tw:border-surface tw:rounded-2xl"
                                [ngClass]="{
                                  'tw:lg:col-span-3':
                                    tabReport.width === '25%' &&
                                    !comparison.isComparisonViewActive(),
                                  'tw:lg:col-span-4':
                                    tabReport.width === '33%' &&
                                    !comparison.isComparisonViewActive(),
                                  'tw:lg:col-span-6':
                                    tabReport.width === '50%' &&
                                    !comparison.isComparisonViewActive(),
                                  'tw:flex tw:flex-wrap tw:p-0! tw:m-0':
                                    comparison.isComparisonViewActive(),
                                  'tw:flex-row-reverse': comparison.flipped(),
                                }"
                                [attr.test-id]="
                                  'figure-' +
                                  (tabReport.comparisonFigure?.name ||
                                    tabReport.leftSimFigure?.name ||
                                    tabReport.rightSimFigure?.name)
                                ">
                                @if (comparison.isComparisonViewActive()) {
                                  <div
                                    class="tw:flex tw:w-full tw:justify-between tw:items-center tw:gap-2 tw:px-3 tw:py-2 tw:border-b tw:border-surface">
                                    <label
                                      class="tw:break-normal tw:text-color tw:font-semibold tw:text-center tw:p-2 tw:block"
                                      style="font-size: 1.2rem"
                                      test-id="report-title">
                                      {{
                                        tabReport.comparisonFigure?.name ||
                                          tabReport.leftSimFigure?.name ||
                                          tabReport.rightSimFigure?.name
                                      }}
                                    </label>
                                  </div>
                                }
                                @if (
                                  comparison.isComparisonViewActive() && tabReport?.comparisonFigure
                                ) {
                                  <cor-job-figure
                                    class="tw:w-full"
                                    [jobFigure]="tabReport.comparisonFigure"
                                    [jobAssets]="evalInfo?.jobAssets || []"
                                    [object]="object()"
                                    [job]="job()"
                                    [showTitle]="false"
                                    [jobName]="
                                      job().name + ' vs ' + (comparison.rightJob()?.name || '')
                                    "
                                    [jobId]="job().id" />
                                } @else if (tabReport?.leftSimFigure) {
                                  <cor-job-figure
                                    [ngClass]="{
                                      'tw:w-1/2': comparison.isComparisonViewActive(),
                                    }"
                                    [jobFigure]="tabReport.leftSimFigure"
                                    [jobAssets]="evalInfo?.jobAssets || []"
                                    [object]="object()"
                                    [job]="job()"
                                    [rerunError]="tabReport.rerunError"
                                    [showTitle]="!comparison.isComparisonViewActive()"
                                    [jobName]="comparison.isComparisonViewActive() && job().name"
                                    [jobId]="job().id"
                                    (onRerunReportFigure)="
                                      rerunReportFigure(tab.reportId, $event)
                                    " />
                                } @else if (tabReport?.rightSimFigure) {
                                  <div
                                    class="tw:w-1/2 tw:flex tw:flex-col tw:justify-center tw:items-center">
                                    <div class="tw:text-xl tw:text-muted-color-emphasis">
                                      No matching output found for
                                    </div>
                                    <div class="tw:text-muted-color tw:font-semibold">
                                      {{ job().name }}
                                    </div>
                                  </div>
                                }

                                <!-- Comparison Job Figure -->
                                @if (
                                  !(
                                    comparison.isComparisonViewActive() &&
                                    tabReport?.comparisonFigure
                                  ) && tabReport?.rightSimFigure
                                ) {
                                  <cor-job-figure
                                    class="tw:w-1/2"
                                    [ngStyle]="{
                                      'border-left':
                                        !comparison.flipped() &&
                                        '0.15em dashed var(--p-content-border-color)',
                                      'border-right':
                                        comparison.flipped() &&
                                        '0.15em dashed var(--p-content-border-color)',
                                    }"
                                    [jobFigure]="tabReport.rightSimFigure"
                                    [jobAssets]="evalInfo?.jobAssets || []"
                                    [object]="object()"
                                    [job]="job()"
                                    [showTitle]="false"
                                    [jobName]="comparison.rightJob()?.name"
                                    [jobId]="comparison.rightJob()?.id" />
                                } @else if (
                                  comparison.isComparisonViewActive() &&
                                  !tabReport?.comparisonFigure
                                ) {
                                  <div
                                    class="tw:w-1/2 tw:flex tw:flex-col tw:justify-center tw:items-center"
                                    [ngStyle]="{
                                      'border-left':
                                        !comparison.flipped() &&
                                        '0.15em dashed var(--p-content-border-color)',
                                      'border-right':
                                        comparison.flipped() &&
                                        '0.15em dashed var(--p-content-border-color)',
                                    }">
                                    @if (comparison.rightJob()) {
                                      <div class="tw:text-xl tw:text-muted-color-emphasis">
                                        No matching output found for
                                      </div>
                                      <div class="tw:text-muted-color tw:font-semibold">
                                        {{ comparison.rightJob()?.name }}
                                      </div>
                                    } @else {
                                      <div class="tw:text-xl tw:text-muted-color-emphasis">
                                        Please select a job to compare
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            } @placeholder {
                              <cor-skeleton-loader
                                class="tw:col-span-12"
                                [count]="1"
                                width="100%"
                                height="450px" />
                            }
                          }
                        </div>
                      }
                    }
                  }
                </p-tabpanel>
              }
            }
          </p-tabpanels>
        </p-tabs>
      </div>
    }
  </div>
} @else {
  <cor-no-data
    [showIcon]="true"
    [noDataMessage]="
      (SIMULATABLE_OBJECTS | includes: object())
        ? 'Your latest COMPLETED job shows up here. Try running a simulation from the \'Run\' button above'
        : 'Jobs used during approval will show up here. First, Run a job anywhere that uses this object and then, use that job during approval here'
    " />
}

<ng-template #actionTemplate>
  <section name="basic">
    <div class="tw:flex tw:justify-end tw:items-center tw:gap-2">
      <!-- Save Changes Button -->
      @if (!comparison.isComparisonViewActive()) {
        @if (object() === OBJECTS.PIPELINE) {
          <p-button
            icon="pi pi-chart-line"
            label="Hillclimb"
            [pTooltip]="
              job().jobStatus === SCHEDULED_JOB_STATUS.COMPLETED
                ? 'Try changing prompts to find the optimal solution for your pipeline'
                : 'Only available for completed jobs'
            "
            [loading]="$any(router.currentNavigation()?.extras.info)?.isHillClimbing"
            [disabled]="
              $any(router.currentNavigation()?.extras.info)?.isHillClimbing ||
              job()?.jobStatus !== SCHEDULED_JOB_STATUS.COMPLETED
            "
            variant="outlined"
            [buttonProps]="{ autofocus: false }"
            [info]="{ isHillClimbing: true }"
            [routerLink]="hillClimbingLink().url"
            [queryParams]="hillClimbingLink().queryParams"
            test-id="hillclimb-button" />
        }
        <p-buttonGroup>
          <p-button
            icon="pi pi-sync"
            label="Rerun"
            [loading]="$any(router.currentNavigation()?.extras.info)?.isRerunning"
            [disabled]="$any(router.currentNavigation()?.extras.info)?.isRerunning"
            severity="success"
            [buttonProps]="{ autofocus: false }"
            [info]="{ isRerunning: true }"
            [routerLink]="rerunLink().url"
            [queryParams]="rerunLink().queryParams"
            test-id="rerun-button" />
          <p-button
            severity="success"
            [buttonProps]="{ autofocus: false }"
            icon="pi pi-chevron-down"
            (click)="rerunOptionsPopover.toggle($event)"
            test-id="rerun-options-button" />
        </p-buttonGroup>
      }

      <!-- Start: Menu Button -->
      <div class="tw:flex">
        <p-button
          [buttonProps]="{ autofocus: false }"
          type="button"
          (click)="menuPopover.toggle($event)"
          rounded
          severity="secondary"
          icon="pi pi-ellipsis-v"
          test-id="job-actions-menu-button" />

        <p-popover
          #menuPopover
          styleClass="job-details-menu">
          <div class="tw:flex tw:flex-col">
            <!-- Open in new window option -->
            <p-button
              [buttonProps]="{ autofocus: false }"
              styleClass="tw:justify-start"
              fluid
              severity="contrast"
              variant="text"
              label="Open in New Window"
              icon="pi pi-external-link"
              (click)="openInNewWindow()"
              test-id="open-in-new-window-button" />

            <!-- Comparison option -->
            @if (canCompare()) {
              <p-button
                [buttonProps]="{ autofocus: false }"
                styleClass="tw:justify-start"
                fluid
                severity="contrast"
                variant="text"
                [label]="
                  comparison.isComparisonViewActive()
                    ? 'Stop Comparison'
                    : 'Compare with other Simulation'
                "
                icon="pi pi-arrow-right-arrow-left"
                (click)="
                  comparison.isComparisonViewActive()
                    ? stopComparisonOption()
                    : showComparisonOption();
                  menuPopover.hide()
                "
                test-id="compare-button" />
            }

            <!-- Pin job -->
            @if (isJobPinnable()) {
              <p-button
                [buttonProps]="{ autofocus: false }"
                styleClass="tw:justify-start"
                fluid
                severity="contrast"
                variant="text"
                [disabled]="isJobPinLoading()"
                [loading]="isJobPinLoading()"
                [label]="job().isPinned ? 'Unpin Dashboard' : 'Pin Dashboard'"
                icon="pi pi-thumbtack"
                (click)="pinDashboard()"
                test-id="pin-dashboard-button" />
            }

            @if (isJobDetailsPage() && job().isOld && writeAccess()) {
              <p-button
                [buttonProps]="{ autofocus: false }"
                styleClass="tw:justify-start"
                fluid
                severity="contrast"
                variant="text"
                label='Remove "old" label'
                icon="pi pi-eraser"
                (click)="removeOldLabelDialog.visible.set(true); menuPopover.hide()" />
            }

            @if (isJobDetailsPage() && isJobDeletable()) {
              <div class="tw:border tw:border-surface"></div>

              <!-- Delete option -->
              <p-button
                [buttonProps]="{ autofocus: false }"
                styleClass="tw:justify-start"
                fluid
                severity="danger"
                variant="text"
                label="Delete"
                icon="pi pi-trash"
                [disabled]="comparison.isComparisonViewActive()"
                [pTooltip]="
                  comparison.isComparisonViewActive() &&
                  'Stop the comparison view to delete the job'
                "
                position="left"
                (click)="deleteJob($event)"
                test-id="delete-job-button" />
            }
          </div>
        </p-popover>
      </div>
      <!-- End: Menu Button -->
    </div>
  </section>
</ng-template>

<!-- Rerun options popover -->
<p-popover #rerunOptionsPopover>
  @if (job()) {
    <p-button
      [buttonProps]="{ autofocus: false }"
      [routerLink]="rerunReportsLink().url"
      [queryParams]="rerunReportsLink().queryParams"
      [info]="{ isRerunning: true }"
      styleClass="tw:justify-start"
      fluid
      severity="contrast"
      variant="text"
      [disabled]="job()?.jobStatus !== SCHEDULED_JOB_STATUS.COMPLETED || jobReports().length === 0"
      [label]="
        $any(router.currentNavigation()?.extras.info)?.isRerunning
          ? 'Preparing...'
          : 'Rerun Reports'
      "
      icon="pi pi-chart-bar"
      test-id="rerun-reports-button"
      [pTooltip]="
        job().jobStatus === SCHEDULED_JOB_STATUS.COMPLETED
          ? jobReports().length === 0
            ? 'Unable to rerun reports as no report was found'
            : 'This will rerun the Reports - but reuse the job output from the existing job.'
          : 'Unable to rerun reports as output data was not found'
      "
      tooltipPosition="left" />
  }
</p-popover>

<p-dialog
  header='Remove "old" label'
  [modal]="true"
  [(visible)]="removeOldLabelDialog.visible"
  [style]="{ width: '36rem', 'max-width': '95vw' }">
  <div class="tw:flex tw:flex-col tw:gap-4">
    <cor-input-container label="Comment (optional)">
      <textarea
        pTextarea
        class="tw:w-full"
        rows="4"
        maxlength="4000"
        [formControl]="removeOldLabelDialog.commentControl"
        placeholder="Explain why the existing results can still be used"></textarea>
    </cor-input-container>

    <div class="tw:flex tw:justify-end tw:gap-2">
      <p-button
        severity="secondary"
        variant="text"
        label="Cancel"
        (click)="removeOldLabelDialog.visible.set(false)" />
      <p-button
        label="Submit"
        (click)="removeOldLabelDialog.submit()" />
    </div>
  </div>
</p-dialog>

<!-- Data preview row side panel -->
<p-drawer
  [(visible)]="previewDataRowPanel.visible"
  position="right"
  styleClass="tw:w-full tw:md:w-3/4 tw:lg:w-1/2"
  [blockScroll]="true"
  (onHide)="previewDataRowPanel.onHide()">
  <ng-template pTemplate="header">
    <div class="tw:flex tw:items-center tw:gap-2 tw:flex-auto">
      <span class="tw:text-3xl">
        {{ previewDataRowPanel.title() }}
      </span>
      @if (previewDataRowPanel.chatMessages()) {
        <p-selectbutton
          test-id="job-dashboard-p-selectbutton"
          [allowEmpty]="false"
          size="small"
          [options]="[
            { label: 'Chat', value: 'chat' },
            { label: 'Conversation Details', value: 'data' },
          ]"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="previewDataRowPanel.view" />
      }

      @if (previewDataRowPanel.visibleRowIndex() >= 0) {
        <p-button
          test-id="job-dashboard-no-remaining-rows"
          [buttonProps]="{ autofocus: false }"
          icon="pi pi-angle-left"
          class="tw:ms-auto"
          size="small"
          variant="outlined"
          severity="secondary"
          [disabled]="!previewDataRowPanel.showPrevious()"
          [pTooltip]="previewDataRowPanel.showPrevious() ? 'Previous Row' : 'No remaining rows'"
          tooltipPosition="bottom"
          (click)="
            DataGridHelpers.updateRowPopupIndex(
              previewDataRowPanel.dataGridInstance()?.instance,
              -1,
              previewDataRowPanel.rowIndex
            )
          " />
        <span
          class="tw:flex tw:shrink-0"
          [pTooltip]="`Unique index: ${previewDataRowPanel.rowIndex() + 1}`"
          tooltipPosition="left">
          Row #{{ previewDataRowPanel.visibleRowIndex() + 1 }}
        </span>
        <p-button
          test-id="job-dashboard-no-remaining-rows-2"
          [buttonProps]="{ autofocus: false }"
          icon="pi pi-angle-right"
          size="small"
          variant="outlined"
          severity="secondary"
          [disabled]="!previewDataRowPanel.showNext()"
          [pTooltip]="previewDataRowPanel.showNext() ? 'Next Row' : 'No remaining rows'"
          tooltipPosition="bottom"
          (click)="
            DataGridHelpers.updateRowPopupIndex(
              previewDataRowPanel.dataGridInstance()?.instance,
              1,
              previewDataRowPanel.rowIndex
            )
          " />
      }
    </div>
  </ng-template>

  @if (previewDataRowPanel.view() === 'data') {
    <p-table
      [value]="previewDataRowPanel.content()"
      stripedRows
      styleClass="p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th class="tw:text-muted-color">Field</th>
          <th class="tw:text-muted-color">Value</th>
        </tr>
      </ng-template>

      <ng-template
        pTemplate="body"
        let-field>
        <tr>
          <td>
            <strong>{{ field.name }}</strong>
          </td>
          <td>
            @if (field.name === CONVERSATION_COLUMN && field.value) {
              <p-button
                test-id="job-dashboard-view-transcript-2"
                [buttonProps]="{ autofocus: false }"
                icon="pi pi-comments"
                label="View Transcript"
                severity="secondary"
                size="small"
                (click)="previewDataRowPanel.view.set('chat')" />
            } @else if (field.value?.toString().startsWith('data:image')) {
              @let viewState = { showRaw: false };
              <div class="tw:group tw:relative">
                <p-button
                  test-id="job-dashboard-show-raw"
                  [buttonProps]="{ autofocus: false }"
                  [label]="viewState.showRaw ? 'Show image' : 'Show raw'"
                  icon="pi pi-eye"
                  size="small"
                  severity="secondary"
                  variant="outlined"
                  styleClass="tw:absolute tw:right-0 tw:top-0 tw:z-10 tw:opacity-0 tw:group-hover:opacity-30 tw:hover:opacity-100 tw:focus-visible:opacity-100 tw:transition-opacity"
                  (click)="viewState.showRaw = !viewState.showRaw" />

                @if (viewState.showRaw) {
                  <pre class="tw:wrap-anywhere tw:whitespace-pre-wrap">{{ field.value }}</pre>
                } @else {
                  <img
                    [src]="field.value"
                    [alt]="`${field.name} image`" />
                }
              </div>
            } @else {
              @let formattedValue = field.value | cellPrettify;
              @if (formattedValue !== field.value) {
                <p-inplace
                  class="tw:w-full"
                  [pt]="{ display: { class: 'tw:p-0!' }, content: { class: 'tw:p-0!' } }">
                  <ng-template #display>
                    <div class="tw:group tw:relative">
                      <p-button
                        test-id="job-dashboard-show-raw-2"
                        [buttonProps]="{ autofocus: false }"
                        label="Show raw"
                        icon="pi pi-eye"
                        size="small"
                        severity="secondary"
                        variant="outlined"
                        styleClass="tw:absolute tw:right-0 tw:top-0 tw:z-10 tw:opacity-0 tw:group-hover:opacity-100 tw:transition-opacity tw:bg-(--p-content-background)" />
                      <pre class="tw:wrap-anywhere tw:whitespace-pre-wrap">{{
                        formattedValue
                      }}</pre>
                    </div>
                  </ng-template>
                  <ng-template
                    #content
                    let-closeCallback="closeCallback">
                    <div class="tw:group tw:relative">
                      <p-button
                        test-id="job-dashboard-show-formatted"
                        [buttonProps]="{ autofocus: false }"
                        label="Show formatted"
                        icon="pi pi-eye"
                        size="small"
                        severity="secondary"
                        variant="outlined"
                        styleClass="tw:absolute tw:right-0 tw:top-0 tw:z-10 tw:opacity-0 tw:group-hover:opacity-100 tw:transition-opacity tw:bg-(--p-content-background)"
                        (click)="closeCallback($event)" />
                      <pre class="tw:wrap-anywhere tw:whitespace-pre-wrap">{{ field.value }}</pre>
                    </div>
                  </ng-template>
                </p-inplace>
              } @else {
                <pre class="tw:wrap-anywhere tw:whitespace-pre-wrap">{{ field.value }}</pre>
              }
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <div class="tw:flex tw:h-full tw:flex-col">
      @if (previewDataRowPanel.chatMessages()?.errorMessage) {
        <p-message
          severity="error"
          variant="simple"
          [motionOptions]="{ disabled: true }"
          styleClass="tw:m-3 tw:whitespace-pre-wrap">
          {{ previewDataRowPanel.chatMessages()?.errorMessage }}
        </p-message>
      }

      @if (previewDataRowPanel.chatMessages()?.interactions?.length > 0) {
        <div class="tw:flex tw:h-full tw:flex-col-reverse tw:overflow-auto">
          <cor-chat
            [interactions]="previewDataRowPanel.chatMessages()?.interactions"
            [testRun]="{
              id: null,
              personName: 'User',
              hasEnded: true,
            }"
            [writeAccess]="false" />
        </div>
      } @else {
        <pre
          class="tw:m-3 tw:rounded-xl tw:bg-emphasis tw:p-2 tw:wrap-anywhere tw:whitespace-pre-wrap!"
          [innerHTML]="previewDataRowPanel.chatMessages()?.rawMessage | cellPrettify"></pre>
      }
    </div>
  }
</p-drawer>

<p-dialog
  header="Data Source"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="reportEvaluations.dataPreview.isVisible"
  [style]="{ 'min-width': '50rem', 'max-width': '90rem' }"
  (onHide)="reportEvaluations.dataPreview.onHide()"
  [focusOnShow]="false">
  @if (reportEvaluations.dataPreview.isVisible()) {
    <div class="row">
      @if (reportEvaluations.dataPreview.dataLogic()?.tableIds?.length > 0) {
        <cor-input-container
          label="Input Tables"
          test-id="input-tables"
          class="col">
          <cor-input-select
            test-id="job-dashboard-cor-input-select"
            [disabled]="true"
            [inputList]="reportEvaluations.inputTablesList()"
            [ngModel]="reportEvaluations.dataPreview.dataLogic()?.tableIds" />
        </cor-input-container>
      }

      @if (reportEvaluations.dataPreview.dataLogic()?.annotationQueueId) {
        <cor-input-container
          label="Annotation Queue"
          test-id="annotation-queue"
          class="col-12 col-md-4">
          <cor-input-select
            test-id="job-dashboard-cor-input-select-2"
            [disabled]="true"
            mode="single"
            [inputList]="reportEvaluations.inputAnnotationQueuesList()"
            [ngModel]="reportEvaluations.dataPreview.dataLogic()?.annotationQueueId"
            valueExpr="id"
            displayExpr="name" />
        </cor-input-container>

        <cor-input-container
          label="Date Range"
          test-id="aq-date-range"
          class="col-12 col-md-4">
          <p-datepicker
            test-id="job-dashboard-no-date-filters-applied"
            [disabled]="true"
            fluid
            selectionMode="range"
            [ngModel]="reportEvaluations.dataPreview.dataLogic()?.aqDateRange"
            placeholder="No date filters applied"
            dateFormat="mm/dd/yy"
            rangeSeparator="to"
            class="disabled-datepicker" />
        </cor-input-container>
      }

      @if (reportEvaluations.dataPreview.dataLogic()?.inputFeatureVersionIds?.length > 0) {
        <cor-input-container
          label="Resources &amp; Inputs"
          test-id="resources"
          class="col-12">
          <cor-input-select
            test-id="job-dashboard-select-other-objects-like-prompts-global"
            placeholder="Select other objects like Prompts, Global Functions, etc. to prepare the data for this Evaluation"
            [inputList]="reportEvaluations.inputResourcesList()"
            valueExpr="uniqueId"
            [searchKeys]="['alias', 'name']"
            [ngModel]="reportEvaluations.dataPreview.dataLogic()?.inputFeatureVersionIds" />
        </cor-input-container>
      }

      @if (
        reportEvaluations.dataPreview.dataLogic()?.tableIds?.length > 0 ||
        reportEvaluations.dataPreview.dataLogic()?.annotationQueueId ||
        reportEvaluations.dataPreview.dataLogic()?.inputType !== MODEL_INPUT_TYPE.PYTHON_FUNCTION
      ) {
        <cor-definition
          test-id="job-dashboard-cor-definition"
          class="col-12"
          [disabled]="true"
          [defnTemplate]="reportEvaluations.dataPreview.dataLogic()?.inputType"
          [object]="object()"
          [inputList]="reportEvaluations.dataLogicInputList()"
          [location]="
            reportEvaluations.dataPreview.dataLogic()?.annotationQueueId
              ? 'job-aq-datasource'
              : 'job-datasource'
          "
          [ngModel]="reportEvaluations.dataPreview.dataLogic()?.definition" />
      }
    </div>
  }
</p-dialog>

<p-dialog
  [header]="reportEvaluations.stepLogsDialog.title()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '75vw', 'max-width': '960px' }"
  [contentStyle]="{ 'max-height': '70vh', overflow: 'auto' }"
  [(visible)]="reportEvaluations.stepLogsDialog.isVisible"
  (onHide)="reportEvaluations.stepLogsDialog.onHide()">
  <cor-code-block
    language="logs"
    [code]="reportEvaluations.stepLogsDialog.logs() || 'No logs captured'" />
</p-dialog>

<p-dialog
  header="Add Evaluation"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="addEvaluationDialog.visible"
  [style]="{ width: '36rem', 'max-width': '95vw' }"
  (onHide)="addEvaluationDialog.close()"
  [focusOnShow]="false">
  <div class="tw:flex tw:flex-col tw:gap-4">
    <cor-input-container label="Name">
      <input
        test-id="job-dashboard-name-control"
        type="text"
        pInputText
        fluid
        [formControl]="addEvaluationDialog.nameControl"
        placeholder="Enter evaluation name" />
      <cor-field-error
        [visible]="
          addEvaluationDialog.nameControl.touched &&
          addEvaluationDialog.nameControl.errors?.required
        "
        errorMsg="Name is required" />
    </cor-input-container>

    <cor-input-container label="Use data from">
      <p-select
        test-id="job-dashboard-data-logic-source-control"
        fluid
        appendTo="body"
        [formControl]="addEvaluationDialog.dataLogicSourceControl"
        [options]="addEvaluationDialog.dataLogics()"
        placeholder="Select data logic"
        optionLabel="name"
        optionValue="id" />
      <cor-field-error
        [visible]="
          addEvaluationDialog.dataLogicSourceControl.touched &&
          addEvaluationDialog.dataLogicSourceControl.errors?.required
        "
        errorMsg="Please select data logic" />
    </cor-input-container>

    <div class="tw:flex tw:justify-end tw:gap-2">
      <p-button
        test-id="job-dashboard-cancel"
        [buttonProps]="{ autofocus: false }"
        severity="secondary"
        variant="text"
        label="Cancel"
        (click)="addEvaluationDialog.close()" />
      <p-button
        test-id="job-dashboard-add"
        [buttonProps]="{ autofocus: false }"
        severity="primary"
        icon="pi pi-plus"
        label="Add"
        [loading]="addEvaluationDialog.isSubmitting()"
        [disabled]="addEvaluationDialog.isSubmitting()"
        (click)="addEvaluation()" />
    </div>
  </div>
</p-dialog>
